/**
 * 前端错误监控 SDK - 数据脱敏与字段裁剪
 */

/** 敏感字段关键词，匹配到则替换值 */
const SENSITIVE_KEYS = /token|password|passwd|secret|auth|credential|cookie|authorization/i;

/** 需要清除的 URL 查询参数名 */
const SENSITIVE_QUERY_PARAMS = new Set([
  'token',
  'access_token',
  'refresh_token',
  'password',
  'secret',
  'key',
  'api_key',
  'auth',
  'authorization',
  'signature',
  'sign',
]);

const MAX_MESSAGE_LENGTH = 1000;
const MAX_STACK_LENGTH = 8000;
const MAX_URL_LENGTH = 500;
const MAX_BREADCRUMB_MESSAGE_LENGTH = 300;

/** 递归脱敏对象（移除敏感字段的值） */
export function sanitizeObject(obj: unknown, depth = 0): unknown {
  if (depth > 5) return '[Truncated]';
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === 'string') return obj.slice(0, 500);
  if (typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) {
    return obj.slice(0, 20).map((item) => sanitizeObject(item, depth + 1));
  }
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    if (SENSITIVE_KEYS.test(key)) {
      result[key] = '[Filtered]';
    } else {
      result[key] = sanitizeObject(value, depth + 1);
    }
  }
  return result;
}

/** 清除 URL 中的敏感 query 参数 */
export function sanitizeUrl(rawUrl: string | undefined): string {
  if (!rawUrl) return '';
  const truncated = rawUrl.slice(0, MAX_URL_LENGTH);
  try {
    const url = new URL(truncated, window.location.origin);
    for (const param of SENSITIVE_QUERY_PARAMS) {
      if (url.searchParams.has(param)) {
        url.searchParams.set(param, '[Filtered]');
      }
    }
    return url.toString().slice(0, MAX_URL_LENGTH);
  } catch {
    // 非标准 URL（如相对路径），只去掉明显 token 串
    return truncated.replace(/([?&])(token|key|auth|secret|sign)[^&]*/gi, '$1$2=[Filtered]');
  }
}

/** 截断 message */
export function sanitizeMessage(message: string | undefined): string {
  if (!message) return 'Unknown error';
  return message.slice(0, MAX_MESSAGE_LENGTH);
}

/** 截断 stack */
export function sanitizeStack(stack: string | undefined): string | undefined {
  if (!stack) return undefined;
  return stack.slice(0, MAX_STACK_LENGTH);
}

/** 截断 breadcrumb message */
export function sanitizeBreadcrumbMessage(message: string): string {
  return message.slice(0, MAX_BREADCRUMB_MESSAGE_LENGTH);
}
